export default [
  {
    path: '/seo/activities',
    name: 'activityList',
    component: () => import('@/views/Seo/Activity/List.vue'),
    meta: {
      layout: 'content'
    }
  },
  {
    path: '/seo/activities/creation',
    name: 'activityCreate',
    component: () => import('@/views/Seo/Activity/Create.vue'),
    meta: {
      layout: 'content'
    }
  },
  {
    path: '/seo/activities/:activityId',
    name: 'activityDetails',
    component: () => import('@/views/Seo/Activity/Details.vue'),
    meta: {
      layout: 'content'
    }
  }
] 